import { useMemo } from 'react';
import type { A11y } from '@wix/editor-react-types';
import type { AriaProps } from '../../../../types/vendored/editor-elements-types-a11y';
import {
  removeAriaPrefix,
  getAccessibilityAttributesSpread,
} from '../../../../utils/a11y';

type UseButtonA11yParams = {
  propsA11y?: A11y;
  ariaAttributes?: AriaProps;
};

export function useButtonA11y({
  propsA11y,
  ariaAttributes,
}: UseButtonA11yParams) {
  const normalizedA11y = useMemo(
    () => removeAriaPrefix(propsA11y ?? {}),
    [propsA11y],
  );

  const a11yAttr = useMemo(
    () =>
      getAccessibilityAttributesSpread({
        ariaAttributes: {
          ...ariaAttributes,
          ...normalizedA11y,
          label: ariaAttributes?.label ?? normalizedA11y.label,
        },
        tabindex: normalizedA11y?.tabindex as 0 | -1,
      }),
    [normalizedA11y, ariaAttributes],
  );

  return a11yAttr;
}
